
<template>
  <div class="pdc-div">
    <div class="danghang-every" v-if="isCommonH">
      <div class="mainContainer">
        <span>当前位置：</span><span @click="goBack" style="padding: 0 5px;cursor: pointer;">课程详情</span>/<span style="padding-left: 5px;">练习题</span>
      </div>
    </div>
    <div class="mainContainer">
      <div class="ks-tiji" id="ks-tiji-divA" v-if="tiji.length>0">
        <div class="ks-ti-block" v-for="(item,i) in tiji" :id="'tijiid'+i">
          <div class="ks-ti-block-xh">{{i+1}}</div>
          <div v-if="item.itype=='1'">
            <div class="ks-ti-block-typeName">[单选题]</div>
            <div class="ks-ti-block-tiName">{{item.cname}}</div>
            <div v-for="(a,i) in item.dalist" :class="(item.islook?((a.iscorrect==1)?'dxright ':((a.order==item.myanswer&&a.iscorrect=='0')?'dxerror ':'')):'')+'testRadioTm testRadioTm'+i">
              <el-radio :disabled="item.islook==1" v-model="item.myanswer" :label="a.order" size="medium">{{a.conts}}</el-radio>
            </div>
            <div v-if="!item.islook"><el-tag type="success" @click="lookDa(i)">看答案</el-tag></div>
            <div v-if="item.islook" style="line-height: 35px;font-size: 14px;color: #111;display: flex;">
              <div style="color: #909399;margin-right: 15px;">试题解析：</div>
              <div>{{item.description}}</div>
            </div>
          </div>
          <div v-if="item.itype=='2'">
            <div class="ks-ti-block-typeName">[多选题]</div>
            <div class="ks-ti-block-tiName">{{item.cname}}</div>
            <div v-for="(a,i) in item.dalist" :class="(item.islook?((a.iscorrect==1)?'dxright ':((item.myanswer.indexOf(a.order)>=0&&a.iscorrect=='0')?'dxerror ':'')):'')+'testCheckboxTm testCheckboxTm'+i">
              <el-checkbox v-model="item.myanswer" :key="a.order" :label="a.order">{{a.conts}}</el-checkbox>
            </div>
            <div v-if="!item.islook"><el-tag type="success" @click="lookDa(i)">看答案</el-tag></div>
            <div v-if="item.islook" style="line-height: 35px;font-size: 14px;color: #111;display: flex;">
              <div style="color: #909399;margin-right: 15px;">试题解析：</div>
              <div>{{item.description}}</div>
            </div>
          </div>
          <div v-if="item.itype=='3'">
            <div class="ks-ti-block-typeName">[判断题]</div>
            <div class="ks-ti-block-tiName">{{item.cname}}</div>
            <div :class="(item.islook&&item.daans=='1'?'dxright ':((item.islook&&item.daans!='1'&&item.myanswer=='1')?'dxerror ':''))+'testRadioTm testRadioTm0'">
              <el-radio :disabled="item.islook==1" v-model="item.myanswer" label="1" size="medium">对</el-radio>
            </div>
            <div :class="(item.islook&&item.daans=='0'?'dxright ':((item.islook&&item.daans!='0'&&item.myanswer=='0')?'dxerror ':''))+'testRadioTm testRadioTm1'">
              <el-radio :disabled="item.islook==1" v-model="item.myanswer" label="0" size="medium">错</el-radio>
            </div>
            <div v-if="!item.islook"><el-tag type="success" @click="lookDa(i)">看答案</el-tag></div>
            <div v-if="item.islook" style="line-height: 35px;font-size: 14px;color: #111;display: flex;">
              <div style="color: #909399;margin-right: 15px;">试题解析：</div>
              <div>{{item.description}}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="background-color: #fff;text-align: center;height: calc(100vh - 171px - 147px);">
        <img style="margin: 100px 0 20px;" src="@/assets/images/nodata.png" />
        <div style="font-size: 18px;color: #999999;">暂无练习题</div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'testQuestion',
    props: ['activeName', 'wjSrc', 'currentUser', 'isCommonH', 'isDenglu'],
    data() {
      return {
        tiji: [],
      }
    },
    methods: {
      getList: function() {
        var url = '/kt/ktQuestions/getCpQuestionsList.htm?id=' + this.$route.query.id;
        // url += '&cid=' + this.currentUser.cid;
        this.$axios.get(url).then(res => {
          var data = res.data;
          var list=[];
          data.data.map((item, i) => {
            var a = [];
            var daans;
            item.dalist.map((d) => {
              // 选择题
              if (item.itype == '1' && d.iscorrect == '1') {
                daans = d.order;
              } else if (item.itype == '2' && d.iscorrect == '1') {
                // 多选题
                a.push(d.order);
              } else if (item.itype == '3') {
                // 判断题
                daans = d.iscorrect;
              }
            });
            var listobj = {
              ...item,
              daans: item.itype == '2' ? a : daans,
              myanswer: item.itype == '2' ?[] : ''
            };
            list.push(listobj);
          });
          this.tiji=list;
        });
      },
      // 查看答案是否正确
      lookDa:function(i){
        var obj=this.tiji[i];
        obj.islook=1;

        this.$set(this.tiji,i,obj);
        // obj.dalist.map((item)=>{
        //   if(item.co)
        // })
      },
      goBack:function(){
        this.$router.go(-1);
      }
    },
    created: function() {
      this.getList();
    }
  }
</script>

<style>
  .ks-tiji {
    height: calc(100vh - 50px - 220px);
    overflow-y: auto;
  }

  .ks-ti-block {
    padding: 26px 40px 26px 66px;
    background: #ffffff;
    margin-bottom: 20px;
    position: relative;
  }

  .ks-ti-block-xh {
    position: absolute;
    width: 44px;
    height: 37px;
    background: url(../assets/images/ksxh.png) 0 0 no-repeat;
    background-size: 100% 100%;
    left: -10px;
    top: 21px;
    color: #fff;
    line-height: 29px;
    text-align: center;
  }

  .ks-ti-block-typeName {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #0071BA;
    line-height: 20px;
    letter-spacing: 1px;
    padding-bottom: 8px;
  }

  .ks-ti-block-tiName {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 20px;
    letter-spacing: 1px;
    margin-bottom: 22px;
  }

  /* 单选的样式   自定义 开始*/
  .testRadioTm {
    padding-bottom: 15px;
    text-align: left;
  }

  .testRadioTm .el-radio__inner {
    width: 24px;
    height: 24px;
    background: #efefef;
    border-radius: 50%;
  }

  .testRadioTm .el-radio__input.is-checked .el-radio__inner {
    background: #0071BA;
    border: 1px solid #0071BA;
  }

  .testRadioTm .el-radio__inner::after {
    background-color: transparent;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
    color: #333;
    line-height: 24PX;
    text-align: center;
  }

  .testRadioTm0 .el-radio__inner::after {
    content: "A";
  }

  .testRadioTm1 .el-radio__inner::after {
    content: "B";
  }

  .testRadioTm2 .el-radio__inner::after {
    content: "C";
  }

  .testRadioTm3 .el-radio__inner::after {
    content: "D";
  }

  .testRadioTm .is-checked .el-radio__inner::after {
    color: #FFF;
  }

  .testRadioTm .el-radio__input.is-checked+.el-radio__label {
    color: #333;
  }
  .testRadioTm.dxright .el-radio__inner::after {
    content: "√";
    background: #00BC68 !important;
    color: #FFF;
  }
  .testRadioTm.dxerror .el-radio__inner::after {
    content: "×";
    background: #D50000 !important;
    color: #FFF;
  }
  /* 单选的样式   自定义 结束*/
  /* 多选的样式   自定义 开始*/
  .testCheckboxTm {
    text-align: left;
    padding-bottom: 15px;
  }

  .testCheckboxTm .el-checkbox__inner {
    width: 24px;
    height: 24px;
    background: #efefef;
    border-radius: 50%;
  }

  .testCheckboxTm .el-checkbox__inner::after {
    background-color: transparent;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
    color: #333;
    line-height: 24PX;
    text-align: center;
  }

  .testCheckboxTm0 .el-checkbox__inner::after {
    content: "A";
  }

  .testCheckboxTm1 .el-checkbox__inner::after {
    content: "B";
  }

  .testCheckboxTm2 .el-checkbox__inner::after {
    content: "C";
  }

  .testCheckboxTm3 .el-checkbox__inner::after {
    content: "D";
  }

  .testCheckboxTm4 .el-checkbox__inner::after {
    content: "E";
  }

  .testCheckboxTm5 .el-checkbox__inner::after {
    content: "F";
  }

  .testCheckboxTm6 .el-checkbox__inner::after {
    content: "G";
  }

  .testCheckboxTm .el-checkbox__input.is-checked .el-checkbox__inner::after {
    transform: translate(-50%, -50%) scale(1);
    background-color: #0071BA;
    color: #fff;
  }

  .testCheckboxTm .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #0071BA;
  }

  .testCheckboxTm .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #0071BA;
    background-color: #0071BA;
  }

  .testCheckboxTm .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #333;
  }
  .testCheckboxTm.dxright .el-checkbox__inner::after {
    content: "√";
    background: #00BC68 !important;
    color: #FFF;
  }

  .testCheckboxTm.dxerror .el-checkbox__inner::after {
    content: "×";
    background: #D50000 !important;
    color: #FFF;
  }
  .el-tag{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/testQuestion.vue